import React from 'react';
import { useUserContext } from '@nexus/fff-utilities';
import { trackEvent } from '@nexus/fff-analytics';

import { reactivateCancelledSubscription } from '../../../services/subscription';
import { getCouponCode, syncDelay } from '../../../helpers';
import styles from './reactivate-button.module.scss';

const ReactivateButton = ({ couponsApplied, isLoading, setIsLoading }) => {
  const { invalidateUserCache } = useUserContext();

  const handleOnClick = () => {
    setIsLoading(true);
    trackEvent({
      ctaName: 'Cancelled Reactivates',
      properties: { coupon_code: getCouponCode(couponsApplied) },
    }).then();

    const sendSegmentEventAfterResponse = (status, callback) => {
      trackEvent({
        ctaName: 'Cancelled Reactivates Result',
        properties: { coupon_code: getCouponCode(couponsApplied), status },
      }).then(callback)
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.warn(e);
          callback();
        });
    };

    reactivateCancelledSubscription(couponsApplied)
      .then((response) => {
        if (response.ok) {
          sendSegmentEventAfterResponse('success', () => {
            invalidateUserCache();
            syncDelay(5000);
            window.location.replace(process.env.REACT_APP_SITE_URL);
          });
        } else {
          sendSegmentEventAfterResponse('failure', () => {
            // eslint-disable-next-line no-console
            console.error('An error had happened', response);
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        sendSegmentEventAfterResponse('failure', () => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
        setIsLoading(false);
      });
  };

  return (
    <button
      type="button"
      className={styles['confirm-reactivate']}
      onClick={handleOnClick}
      disabled={isLoading}
    >
      REACTIVATE NOW
    </button>
  );
};

export default ReactivateButton;
